<template>
  <div v-show="show"  :style="{position: 'absolute',top: position.y+'px',left: position.x+'px'}">
    <el-card class="data-card" body-style="padding: 0">
      <div  class="data-card-head">
        <span>{{openData.mpcd}}<span v-show="needStatus" style="color: #ea3d31;margin-left: 0.2rem;">{{openData.status === 1  ? '' : '异常'}}</span></span>
        <span>{{openData.mstm}}</span>
      </div>
      <div class="data-card-body">
        <div class="data-card-body-data"  v-for="item in activeColumns" :key="item.property">
          <span class="data-card-body-label">{{item.label}}</span>
          <span class="data-card-body-content">{{openData[item.property] ? openData[item.property] : '--'}}</span>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
const columnTypes =
    {
      '0601': [{
        property: 'data1',
        label: '测压管水位(m)',
      },
        {
          property: 'data2',
          label: '实际水深(m)',
        },
        {
          property: 'wt',
          label: '温度(℃)',
        }],
      '0602':
          [
            {
              property: 'data1',
              label: '渗流压力水位(m)',
            },
            {
              property: 'wt',
              label: '温度(℃)',
            }]
      , '0603':
          [{
            property: 'data1',
            label: '应变(10^(-6))',
          },
            {
              property: 'wt',
              label: '温度(℃)',
            }]
      , '0604':
          [{
            property: 'data1',
            label: 'X向水平位移(mm)',
          },]
      , '0605':
          [{
            property: 'data1',
            label: 'Y向水平位移(mm)',
          }],
      '0606':
          [{
            property: 'data1',
            label: '垂直位移(mm)',
          }]
    };
export default {
  name: "pointDetail",
  data() {
    return {
      openData: {
        mpcd: '',
        mstm: '',
        data1: '',
        data2: '',
        wt: '',
        status:  ''
      },
      activeColumns: [],
      needStatus: false,
      show: false,
      position: {
        top: 0,
        left: 0
      }
    };
  },

  methods: {
    changeData(data){
      this.openData = data;
    },
    positionChange(isShow,position,active,data,needStatus){
        // if()
      if(isShow){
        if(!this.show){
          this.show = isShow;
          this.position = position;
          this.activeColumns = columnTypes[active];
          this.openData = data;
          this.needStatus = needStatus;
          console.log(data);
        }
      }else {
        if(this.show){
          this.show = isShow;
        }
      }
    },
  },
}
</script>
<style scoped lang="less">
.data-card{
  min-width: 26rem;
}
.data-card-head{
  width: calc(100% - 2rem);
  font-family: "PingFang SC";
  color: #FFFFFF;
  font-size: 1.4rem;
  background-color: rgb(44,131,234);
  padding: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.data-card-body{
  width: calc(100% - 3rem);
  background-color: #FFFFFF;
  padding: 1.5rem;
}
.data-card-body-label{
  width: 50%;
  color: black;
  font-family: "PingFang SC";
  font-size: 1.4rem;

}
.data-card-body-content{
  width: 50%;
  color: rgb(44,131,234);
  font-family: "PingFang SC";
  font-size: 1.4rem;
  display: flex;
  justify-content: flex-end;
}
.data-card-body-data{
  width: calc(100% - 2rem);
  background-color: rgb(247,247,247);
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
